import { Auth } from "aws-amplify";
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient, PutCommand } from "@aws-sdk/lib-dynamodb";
import {
  RegionalDomain,
  getBartLambdaConfig,
} from "src/config/BartLambdaConfig";

const TABLE_NAME = "BARTAuditHistoryTable";

export interface AuditHistoryParams {
  userId: string;
  operationType: string;
  additionalInfo: string;
  reasoning: string;
}

// --- Additional Info Templates ---

export function updatePlanAdditionalInfo(planId: string): string {
  return `Plan Id: ${planId}`;
}

export function remapArdToPlanAdditionalInfo(planId: string): string {
  return `Plan Id: ${planId}`;
}

export function ardNewPlanMappingAdditionalInfo(
  planId: string,
  ardId: string,
): string {
  return `Plan Id: ${planId}, ARD Id: ${ardId}`;
}

export function updateFixedFeeStatusAdditionalInfo(
  fixedFeeId: string,
  status: string,
  withValidation: boolean,
): string {
  return `Fixed Fee Id: ${fixedFeeId}, Target Status: ${status}, With Validation: ${withValidation}`;
}

export function singularRedriveAdditionalInfo(
  externalId: string,
  workflowType: string,
  eventVersionOverride: string,
  fusenExecutionMode: string,
  createNewWorkflow: string,
  environment: string,
): string {
  return (
    `External Id: ${externalId}, Workflow Type: ${workflowType}, ` +
    `Event Version Override: ${eventVersionOverride}, ` +
    `FUSEN Execution Mode: ${fusenExecutionMode}, ` +
    `Create Fusen Workflow: ${createNewWorkflow}, Environment: ${environment}`
  );
}

export function bulkRedriveAdditionalInfo(bulkRequestId: string): string {
  return `Bulk Request Id: ${bulkRequestId}`;
}

export function dlqMoverAdditionalInfo(
  command: string,
  queueName: string,
): string {
  return `Command : ${command}, Queue Name : ${queueName}`;
}

// --- Put Audit History ---

export async function putAuditHistory(
  domain: RegionalDomain,
  params: AuditHistoryParams,
): Promise<void> {
  try {
    const credentials = await Auth.currentCredentials();
    const client = new DynamoDBClient({
      credentials: Auth.essentialCredentials(credentials),
      region: getBartLambdaConfig(domain).awsRegion,
    });

    const docClient = DynamoDBDocumentClient.from(client);
    const requestTime = new Date().toISOString().slice(0, 19).replace("T", " ");

    const command = new PutCommand({
      TableName: TABLE_NAME,
      Item: {
        userId: params.userId,
        requestTime,
        operationType: params.operationType,
        additionalInfo: params.additionalInfo,
        reasoning: params.reasoning,
      },
    });

    await docClient.send(command);
  } catch (error) {
    console.error("Failed to write audit history", error);
  }
}
